module.exports = __webpack_public_path__ + "static/empty.fa582f3d.png";